import { Controller } from 'stimulus';
import events from 'lib/events';

const fbqEventsListOnce = [
  events.download_btn.initial_click,
  events.checkout.purchase,
];

const fbqEventsListAlways = [];

export default class FacebookAnalyticsController extends Controller {
  connect() {
    this.loadFB(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');

    this.fbq('init', '556962091911454');

    if (!this.isTurbolinksPreview) {
      this.fbq('track', 'PageView');
    }

    this.removeListeners(fbqEventsListOnce, { once: true });
    this.removeListeners(fbqEventsListAlways, { once: false });

    this.registerListeners(fbqEventsListOnce, { once: true });
    this.registerListeners(fbqEventsListAlways, { once: false });
  }

  disconnect() {
    this.removeListeners(fbqEventsListOnce, { once: true });
    this.removeListeners(fbqEventsListAlways, { once: false });
  }

  registerListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.addEventListener(eventName, this.transformEvent, options);
    });
  }

  removeListeners(eventsList, options) {
    eventsList.forEach((eventName) => {
      window.removeEventListener(eventName, this.transformEvent, options);
    });
  }

  transformEvent = (event) => {
    // Clone the event so we don't modify the original and possibly affect other components listening for the event
    const transformedEvent = { ...event };
    transformedEvent.detail = { ...event.detail };

    switch (event.type) {
      case events.download_btn.initial_click:
        transformedEvent.detail.fbqEventCategory = 'trackCustom';
        transformedEvent.detail.fbqEventName = 'Download';
        break;

      case events.checkout.purchase:
        transformedEvent.detail.fbqEventCategory = 'track';
        transformedEvent.detail.fbqEventName = 'Purchase';
        transformedEvent.detail.fbqEventOptions = {
          value: event.detail.transactionAmount,
          currency: event.detail.currency,
        };
        break;

      default:
        /* Do nothing */
    }

    if (transformedEvent.detail) {
      this.trackEvent(transformedEvent);
    }

    return true;
  }

  trackEvent = (event) => {
    if (event.detail.fbqEventOptions) {
      this.fbq(event.detail.fbqEventCategory, event.detail.fbqEventName, event.detail.fbqEventOptions);
    } else {
      this.fbq(event.detail.fbqEventCategory, event.detail.fbqEventName);
    }
  }

  /* eslint-disable */
  loadFB = function (f, b, e, v, n, t, s) {
    if (f.fbq) return;
    n = f.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    };
    if (!f._fbq) { f._fbq = n; }
    n.push = n;
    n.loaded = !0;
    n.version = '2.0';
    n.queue = [];
    t = b.createElement(e);
    t.async = !0;
    t.src = v;
    s = b.getElementsByTagName(e)[0];
    s.parentNode.insertBefore(t, s);
  };
  /* eslint-enable */

  fbq(...args) {
    window.fbq(...args);
  }

  get isTurbolinksPreview() {
    return document.documentElement.hasAttribute('data-turbolinks-preview');
  }
}
